<template>
  <div
      class="dragdrop-container flex-center-column"
      :class="[size, { dragging, skeleton: loading }]"
      @dragover="dragging = true"
      @dragleave="dragging = false"
  >
    <input
        v-if="!disabled && !loading"
        :key="inputKey"
        type="file"
        class="file-input pointer"
        @change="fileSelectHandler"
        @drop="fileSelectHandler"
        :value="null"
        :accept="allowedExtensionsAccept"
        ref="fileInput"
    />
    <Text
        :size="size === 'xl' ? 'h4' : 'p3'"
        class="upload-label"
    >
      {{ uploadLabel }}
    </Text>
    <Text
        v-if="allowedExtensions.length && size !== 'xs'"
        size="p7"
        :color="size === 'xl' ? 'medium' : 'dark'"
        class="extensions-types"
    >
      Files format : {{ allowedExtensionsText }}
    </Text>
    <Text v-if="description" size="p6">{{ description }}</Text>
  </div>
</template>

<script>

export default {
  name: "FileDragDropInput",
  props: {
    size: {
      type: String,
      validator: (value) => ["", "xs", "sm", "lg"].includes(value),
    },
    allowedExtensions: {
      type: Array,
      default() {
        return ["csv", "xlsx", "txt", "zip", "7z", "tar", "gz"];
      },
    },
    multiple: Boolean,
    disabled: Boolean,
    label: String,
    disabledLabel: String,
    loading: Boolean,
    description: {
      type: String,
      default: null,
    },
    isCancel: Boolean,
  },
  data() {
    return {
      inputKey: 0,
      dragging: false,
    };
  },
  computed: {
    allowedExtensionsAccept() {
      return this.allowedExtensions
          .map((extension) => `.${extension.toLowerCase().trim()}`)
          .join(",");
    },
    allowedExtensionsText() {
      return this.allowedExtensions.join(" / ");
    },
    uploadLabel() {
      if (this.disabled) {
       return this.isCancel ? "Canceling upload ..." : this.disabledLabel || 'File is uploading ...';
      }
      return (
          this.label ||
          `Click or drag & drop to upload ${this.multiple ? "files" : "a file"}`
      );
    },
  },
  methods: {
    showFileUpload() {
      this.$refs.fileInput.click();
    },
    fileSelectHandler(e) {
      this.dragging = false;
      let files = e.target.files;
      files = Array.from(files).filter((file) =>
          this.allowedExtensions.some((extension) =>
              file.name.toLowerCase().endsWith(extension.toLowerCase())
          )
      );
      if (!files.length) {
        return;
      }
      this.$emit("upload", this.multiple ? files : files[0]);
      this.inputKey += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
.dragdrop-container {
  border: 1.8px dashed;
  height: 205px;
  position: relative;
  .extensions-types{
    font-weight: 300;
    opacity: 1;
  }
  .file-input {
    position: absolute;
    inset: 0;
    width: 100%;
    opacity: 0;
    z-index: 1;
  }

  svg {
    width: 22.4px;
    height: 29.87px;
  }

  .icon-container {
    min-width: 64px;
    min-height: 64px;
    border-radius: 50%;
    margin-bottom: 12px;
  }

  .upload-label {
    margin-bottom: 8px;
  }

  &:hover,
  &.dragging {
    background: #f7fafe;
  }

  &.sm,
  &.xs {
    width: 424px;
  }

  &.sm {
    height: 173px;

    .icon-container {
      min-width: 48px;
      min-height: 48px;
    }

    .upload-label {
      margin-bottom: 4px;
    }

    svg {
      width: 16.8px;
      height: 22.4px;
    }
  }

  &.xs {
    height: 58px;

    .upload-label {
      margin-bottom: 0;
    }
  }
}
</style>
